import { render } from "./HeadingRegister.vue?vue&type=template&id=3802a0b2&scoped=true"
import script from "./HeadingRegister.vue?vue&type=script&lang=js"
export * from "./HeadingRegister.vue?vue&type=script&lang=js"

import "./HeadingRegister.vue?vue&type=style&index=0&id=3802a0b2&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3802a0b2"]])

export default __exports__